<template>
  <ul>
    <!-- <p>(برای اضافه کردن زیر گره، روی گره مورد نظر دابل کلیک نمائید)</p> -->
    <li class="add" @keyup="addRootChild($event)" v-if="options.access.add||options.access.edit">
      <input
        v-for="(item,index) in options.fields"
        ref="rootInsert"
        id="root-input"
        class="form-control tree-input"
        type="item.type"
        :key="index"
        :placeholder="item.title"
        v-model="model[index]"
      >
    </li>
    <bd-tree-node
      class="item"
      @add="addChild"
      @update="updateChild"
      @deleteNode="deleteChild"
      v-for="(item, index) in treeData"
      :key="index"
      :index="index"
      :model="treeData[index]"
      :options="options"
      :data="allData"
    ></bd-tree-node>
  </ul>
</template>

<script>
import EventBus from "../bus.js";
import BdTreeNode from "./BDTreeNode.vue";
import BaseService from "../_framework/api/BaseService.js";
import * as $ from "jquery";
export default {
  name: "bd-tree",
  components: {
    BdTreeNode
  },
  props: {
    options: {
      fields: null
    }
  },
  data: () => {
    return {
      model: {},
      code: null,
      treeData: {},
      allData: null
    };
  },
  methods: {
    addChild(data, parentId) {
      if (parentId) {
        data.parentId = parentId;
      }
      new BaseService(this.options.entityName).create(data).then(rs => {
        this.getNodes();
      });
    },
    updateChild(data) {
      new BaseService(this.options.entityName).update(data).then(rs => {
        this.getNodes();
      });
    },
    addRootChild(e) {
      if (e.key === "Enter") {
        var data = {};
        // let isValid = false;
        // console.log(this.options.fields);
        // if (this.model) {
        //   for (i in this.options.fields) {
        //     console.log(i);
        //     if (!this.model[i].trim()) {
        //       isValid = false;
        //     } else {
        //       isValid = true;
        //     }
        //   }
        //   if (isValid) {
        //     this.addChild(this.model);
        //     this.model = {};
        //   }
        // }
        // if (!isValid || !this.model) {
        //   this.$noty.error("اطلاعات مورد نیاز را وارد کنید");
        // }
        this.addChild(this.model);
        this.model = {};
      }
    },
    deleteChild(id) {
      new BaseService(this.options.entityName).delete(id.id).then(rs => {
        this.getNodes();
      });
    },
    rootInsert(e) {
      $("#root-input").focus();
    },
    getNodes() {
      new BaseService(this.options.entityName).getList().then(response => {
        this.treeData = response.data;
      });
      // .catch(error => {});
      new BaseService(this.options.entityName).getAll().then(rs => {
        this.allData = rs.data;
      });
    }
  },
  mounted() {
    this.getNodes();
    EventBus.$on("rootInsert", () => {
      this.rootInsert();
    });
    // EventBus.$on("add", (data, parentId) => {
    //   this.addChild(data, parentId);
    // });
  }
};
</script>

<style scoped lang="scss">
body {
  font-family: Menlo, Consolas, monospace;
  color: #444;
}
.item {
  cursor: pointer;
}
.bold {
  font-weight: bold;
}
ul {
  padding-left: 1em;
  line-height: 1.5em;
  list-style-type: dot;
}
.add:hover {
  cursor: pointer;
}
.tree-input {
  width: 130px;
  height: 25px;
  display: inline-flex;
  margin-left: 1em;
}
</style>
